import type { Rule } from "antd/es/form";

export const createEmailRule = (errorMessage: string): Rule => ({
  validator: (_, value: string) => {
    if (!value) return Promise.resolve();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value)
      ? Promise.resolve()
      : Promise.reject(new Error(errorMessage));
  },
});
